import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import github from '../images/github.png';
import facebook from '../images/facebook.png';
import twitter from '../images/twitter.png'
import instagram from '../images/instagram.png'
import linkdin from '../images/linkdin.png'
import youtube from '../images/youtube.png'
import pinterest from '../images/pinterest.png'
import snapshat from '../images/snapshat.png'
import tiktok from '../images/tiktok.png'
import reddit from '../images/reddit.png'
import whatsapp from '../images/whatsapp.png'
import { useTranslation } from 'react-i18next';



function SocialMediaEdit({ dragHandleProps }) {

  const { t } = useTranslation();

  const apiUrl = process.env.REACT_APP_BACKEND_URL

  let LanguageSelected = Cookies.get('LanguageSelected');



  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');

  const [SocialModal, setSocialModal] = useState(false)
  const [EditSocialModal, setEditSocialModal] = useState(false)


  const [InputsErrors, setInputsErrors] = useState([])

  const [SocialsInfo, setSocialsInfo] = useState('')
  const [Done, setDone] = useState(false)

  const [SocialsId, setSocialsId] = useState()


  const [SocialsContent, setSocialsContent] = useState([])

  const socialMediaIcons = [
    { name: 'Facebook', icon: facebook },
    { name: 'Twitter', icon: twitter },
    { name: 'Instagram', icon: instagram },
    { name: 'LinkedIn', icon: linkdin },
    { name: 'YouTube', icon: youtube },
    { name: 'Pinterest', icon: pinterest },
    { name: 'Snapchat', icon: snapshat },
    { name: 'TikTok', icon: tiktok },
    { name: 'Reddit', icon: reddit },
    { name: 'WhatsApp', icon: whatsapp },
    { name: 'GitHub', icon: github },
    // Add more social media icons as needed
  ];


  const [isFetching, setIsFetching] = useState(false);


  useEffect(() => {
    if (SocialModal || EditSocialModal) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [SocialModal, EditSocialModal]);


  const AddingSocialsInfo = (e) => {
    return setSocialsInfo({ ...SocialsInfo, [e.target.name]: e.target.value })

  }
  const SetSocialsToUpdateDefaultValues = (id) => {
    const social = SocialsContent.find(service => service.id == id)
    return setSocialsInfo({ ...SocialsInfo, SocialsId: id, url: social.url, nameSocial: social.nameSocial })

  }

  useEffect(() => {
    fetch(`${apiUrl}/GetSocialsInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setSocialsContent(result.data)
          setSocialsInfo({ ...SocialsInfo, user_id: userId })


        }
      })
  }, [Done])

  const StoreSocialsInfo = (e) => {

    setIsFetching(true);

    e.preventDefault()
    fetch(`${apiUrl}/StoreSocialsInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify(SocialsInfo)
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setSocialsInfo('')
          setDone(!Done)
          setInputsErrors([])
          setSocialModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.errors)

        }
      })
      .finally(() => {
        setIsFetching(false);
      });



  }

  const UpdateSocialsInfo = (e) => {

    setIsFetching(true);

    e.preventDefault()
    fetch(`${apiUrl}/UpdateSocialsInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify(SocialsInfo)
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setSocialsInfo('')
          setDone(!Done)
          setInputsErrors([])
          setEditSocialModal(false)
          toast.success(result.message, {
            position: toast.POSITION.CENTER
          });

        }
        else {
          setInputsErrors(result.errors)


        }
      })
      .finally(() => {
        setIsFetching(false);
      });
  }


  const DeleteSocialsInfo = (e, id) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeleteSocialsInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ SocialsId: id })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)

        }
      })
  }

  const existingSocialNames = SocialsContent.map(icon => icon.nameSocial);
  const uniqueSocialNames = socialMediaIcons.filter(social => !existingSocialNames.includes(social.name));


  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>
      <section className="socials  sections rounded-xl pt-3 pb-3 pl-3 m-3">
        <div className="pb-2">
          <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-4' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>{t("Réseaux sociaux")}</h1>
        </div>
        <div className="pl-2 pr-4 w-full ">
          <div className="grid  grid-cols-1 gap-4">
            <div className="col-span-12 sm:col-span-6 md:col-span-3">

              {SocialsContent != '' &&

                SocialsContent.map(social => {
                  return (
                    <>
                      <div className="relative mx-auto gap-3 flex flex-row div-sections  rounded p-4 mt-4" key={social.id}>

                        <div className="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded bg-#B8996C text-black">
                          <a href={social.url} target='_blank'>
                            {
                              socialMediaIcons.map(icon => {
                                if (social.nameSocial === icon.name) {
                                  return (
                                    <img className='w-10 ' src={icon.icon} />

                                  )
                                }

                              })
                            }

                          </a>
                        </div>
                        <div className="grid place-items-center  text-about">
                          <span className="relative font-bold text-xl">{social.nameSocial}</span>

                        </div>
                        <div className={`${LanguageSelected == 'ar' ? 'flex items-center absolute left-3 mt-3 ' : 'flex items-center absolute right-1 mt-3 '}`}>

                          <svg onClick={() => { setEditSocialModal(true); SetSocialsToUpdateDefaultValues(social.id); setSocialsId(social.id) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                          </svg>
                          <svg onClick={(e) => { DeleteSocialsInfo(e, social.id) }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 mr-0.5' : 'w-6 mr-5'}`}>
                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                          </svg>
                        </div>
                      </div>

                    </>



                  )
                })}
            </div>
          </div>
        </div>

        <a onClick={() => { setSocialModal(true) }}>

          <main className="flex p-5  items-center justify-center ">
            <label htmlFor="dropzone-file-inputsocial" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded border-2 border-dashed border-gold div-sections p-6 text-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="mt-2 text-about tracking-wide">{t("Entrez vos réseaux sociaux.")} </p>
            </label></main></a>
        <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clip-rule="evenodd" />
          </svg>

        </div>
      </section>


      {SocialModal &&

        <div>

          <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setSocialModal(false); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl text-theme mb-2">{t("Réseaux sociaux")}</h2>
              <form className="space-y-6 text-about">
                <div>
                  <label htmlFor="email" className="textModal">{t("Choisissez parmi une multitude de réseaux sociaux pour montrer ce qui compte le plus pour vous")}</label>
                  <div>
                    <select onChange={(e) => AddingSocialsInfo(e)} name='nameSocial' className="mt-5 block   px-3 py-2 bg-gray-700   rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm w-44   ">
                      <option selected disabled>{t("Choisir")}</option>
                      {

                        uniqueSocialNames.map(social => (
                          <option key={social.name} value={social.name}>
                            {social.name}
                          </option>
                        ))
                      }



                    </select>
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('nameSocial') && InputsErrors.nameSocial}</span></p>

                  </div>
                  <div className="mt-5">
                    <input onChange={(e) => AddingSocialsInfo(e)} type="text" id="Link" name="url" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer le lien de votre compte")} required />
                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('url') && InputsErrors.url}</span></p>

                  </div>
                </div>
                <button onClick={(e) => StoreSocialsInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                  {t("enregistrer")}
                </button>
              </form></div>
          </div>
        </div>



      }


      {EditSocialModal &&
        SocialsContent.map(social => {
          if (social.id == SocialsId) {
            return (

              <div>

                <div className="minscreen h-full animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-50 forms-info ">
                  <div className="absolute top-0 right-0 p-4">
                    <a className='w-12 h-12' onClick={() => { setEditSocialModal(false); setInputsErrors([]) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                      </svg>
                    </a>
                  </div>
                  <div className="w-full max-w-sm  p-8  rounded-md">
                    <h2 className="text-3xl text-theme mb-2">{t("Réseaux sociaux")}</h2>
                    <form className="space-y-6 text-about">
                      <div>
                        <label htmlFor="email" className="textModal">{t("Choisissez parmi une multitude de réseaux sociaux pour montrer ce qui compte le plus pour vous")}</label>
                        <div>
                          <select onChange={(e) => AddingSocialsInfo(e)} name='nameSocial' className="mt-5 block   px-3 py-2 bg-gray-700   rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm w-44   ">
                            <option selected value={social.nameSocial}>{social.nameSocial}</option>
                            {

                              uniqueSocialNames.map(social => (
                                <option key={social.name} value={social.name}>
                                  {social.name}
                                </option>
                              ))
                            }



                          </select>
                          <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('nameSocial') && InputsErrors.nameSocial}</span></p>

                        </div>
                        <div className="mt-5">
                          <input defaultValue={social.url} onChange={(e) => AddingSocialsInfo(e)} type="text" id="Link" name="url" className="appearance-none block w-full placeholder-sm h-14 px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Entrer le lien de votre compte")} required />
                          <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('url') && InputsErrors.url}</span></p>

                        </div>
                      </div>
                      <button onClick={(e) => UpdateSocialsInfo(e)} disabled={isFetching} type="submit" className="w-full btn-edit">
                        {t("enregistrer")}
                      </button>
                    </form></div>
                </div>
              </div>



            )
          }
        })

      }




    </div>
  )
}

export default SocialMediaEdit